var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./node_modules/.4.17.10@lodash/_Symbol.js
// module id = 92
// module chunks = 1